import { vuexEventPathGenerator } from '@/utils';
export const mutationType = {
    PRINT: 'PRINT',
};
export const allocationAlertMutationType = vuexEventPathGenerator(mutationType, 'allocationAlert');
const mutations = {
    [mutationType.PRINT]: () => {
        // allocationAlert 컴포넌트에서 구독
    },
};
export default mutations;
